import React from 'react';
import LazyTable from 'app/component/lazy-table';
import { Checkbox } from 'primereact/checkbox';

const ClientNewsTable: React.FC = () => {
  const showToClientCheckbox = zaplatene => {
    return <Checkbox disabled={true} style={{ marginLeft: '1rem' }} checked={zaplatene as boolean} />;
  };

  return LazyTable({
    initialSortField: 'id',
    initialSortDirection: 'desc',
    createUrl: '/create-client-news',
    labelForCreateEntity: 'Vytvoriť novinku pre klienta',
    serverUrl: '/api/client-news',
    editActionAllowed: true,
    searchAllowed: false,
    globalFilterFields: ['businessName', 'firstName', 'lastName', 'email'],
    columns: [
      { field: 'id', header: 'ID', sortable: true },
      { field: 'showToClients', header: 'Ukázať klientovi', sortable: true, formatter: showToClientCheckbox },
      { field: 'title', header: 'Názov novinky', sortable: true },
    ],
  });
};

export default ClientNewsTable;
